"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7603],{

/***/ 14224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ido_InvestmentIframe; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/services/i18n.ts + 3 modules
var i18n = __webpack_require__(61839);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hooks-global-state/dist/index.modern.js + 2 modules
var index_modern = __webpack_require__(3558);
;// CONCATENATED MODULE: ./src/hooks/ido/useIDOReferral.tsx




var useGlobalState = (0,index_modern/* createGlobalState */.r)({
    referral: undefined
}).useGlobalState;
function useIDOReferral() {
    var router = (0,next_router.useRouter)();
    var referral = router.query.des;
    var ref = (0,_sliced_to_array/* default */.Z)(useGlobalState("referral"), 2), referralState = ref[0], setReferralState = ref[1];
    (0,react.useEffect)(function() {
        if (referralState) {
            router.replace({
                query: {
                    des: referralState
                }
            });
        }
    }, [
        referralState
    ]);
    (0,react.useEffect)(function() {
        setReferralState(referral);
    }, [
        referral
    ]);
    return {
        referral: referral
    };
}

// EXTERNAL MODULE: ./src/services/ido.ts
var ido = __webpack_require__(59498);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(67841);
// EXTERNAL MODULE: ./src/components/ido/UserInvestmentInfoDialog.tsx
var UserInvestmentInfoDialog = __webpack_require__(18084);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-disclosure/use-disclosure.js
var use_disclosure = __webpack_require__(91759);
// EXTERNAL MODULE: ./src/hooks/useAccount.tsx
var useAccount = __webpack_require__(98786);
;// CONCATENATED MODULE: ./src/components/ido/InvestmentIframe.tsx











var InvestmentIframe = function(param) {
    var investInfo = param.investInfo, campaignId = param.campaignId, campaignSrc = param.campaignSrc;
    var locale = investInfo.locale;
    var router = (0,next_router.useRouter)();
    var referral = useIDOReferral().referral;
    var ref = (0,useAccount/* default */.Z)(), address = ref.address, login = ref.login;
    var round = ido/* currentRound */.H4;
    var hideInvest = ido/* IDO_STAGE */.J_ === ido/* IDOStage.ROUND_1_END */.jA.ROUND_1_END || ido/* IDO_STAGE */.J_ === ido/* IDOStage.ROUND_2_END */.jA.ROUND_2_END;
    var isCN = router.pathname === "/ido/cn";
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,use_disclosure/* useDisclosure */.q)(false), 2), investDialogOpened = ref1[0], ref2 = ref1[1], openInvestDialog = ref2.open, closeInvestDialog = ref2.close;
    console.log("campaignId", campaignId);
    console.log("campaignSrc", campaignSrc);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col items-center px-5 sm:px-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    async: true,
                    src: campaignSrc
                })
            }),
            hideInvest ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-center text-6xl sm:text-[100px] font-extrabold text-dark1 leading-none",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: i18n/* default.t */.Z.t("initial", locale)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-primary",
                        children: i18n/* default.t */.Z.t("dex", locale)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: i18n/* default.t */.Z.t("offering", locale)
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-3xl font-extrabold sm:text-5xl",
                        children: i18n/* default.t */.Z.t("investment.title", locale)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center mt-5 text-sm",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    i18n/* default.t */.Z.t("target_goal", locale),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "block font-semibold text-center sm:inline",
                                        children: round === 1 ? "$0.5 million" : "$3.5 million"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-6 w-[1px] bg-gray1 mx-4"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    i18n/* default.t */.Z.t("price", locale),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "block font-semibold text-center sm:inline",
                                        children: round === 1 ? "$0.03" : "$0.035"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-6 w-[1px] bg-gray1 mx-4"
                            }),
                            round === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    "July ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "font-semibold",
                                        children: "19"
                                    }),
                                    " - July",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "font-semibold",
                                        children: "21"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    "July ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "font-semibold",
                                        children: "22"
                                    }),
                                    " - August",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "font-semibold",
                                        children: "19"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            referral && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-8 p-8 bg-[#FFDB83] text-sm font-semibold text-center rounded-lg sm:w-[458px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: "You are visiting from a referral link."
                    }),
                    !isCN && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: "Purchases made through the KOL link will receive a bonus."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-8",
                children: [
                    !hideInvest && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "deshilling-button",
                        "data-campaign-id": campaignId,
                        className: "flex flex-col items-center sm:bg-white rounded-lg sm:w-[458px] sm:shadow-card1 overflow-hidden sm:h-[460px]"
                    }),
                    ido/* IDO_STAGE */.J_ === ido/* IDOStage.ROUND_1_END */.jA.ROUND_1_END && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-8 shadow-card1 bg-[#E0E1E1] p-6 rounded-lg",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "px-4 py-2 text-sm font-semibold text-center rounded-lg",
                                style: {
                                    background: "rgba(255, 255, 255, 0.50)"
                                },
                                children: "Round one complete"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center justify-center text-sm mt-7",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            i18n/* default.t */.Z.t("investment.target_goal", locale),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "font-semibold",
                                                children: "$0.5 million"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "h-6 w-[1px] bg-gray1 mx-4"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            i18n/* default.t */.Z.t("price", locale),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "font-semibold",
                                                children: "$0.03"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "h-6 w-[1px] bg-gray1 mx-4"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            "July ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "font-semibold",
                                                children: "19"
                                            }),
                                            " - July",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "font-semibold",
                                                children: "22"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    round === 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-8 shadow-card1 bg-[#FFDB83] p-6 rounded-lg",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "px-4 py-2 text-sm font-semibold text-center rounded-lg",
                                style: {
                                    background: "rgba(255, 255, 255, 0.50)"
                                },
                                children: i18n/* default.t */.Z.t("investment.second_round_coming_soon", locale)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center justify-center text-sm mt-7",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            i18n/* default.t */.Z.t("investment.target_goal", locale),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "font-semibold",
                                                children: i18n/* default.t */.Z.t("investment.3million", locale)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "h-6 w-[1px] bg-gray1 mx-4"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            i18n/* default.t */.Z.t("price", locale),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "font-semibold",
                                                children: "$0.035"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "h-6 w-[1px] bg-gray1 mx-4"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            "July ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "font-semibold",
                                                children: "22"
                                            }),
                                            " - August",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "font-semibold",
                                                children: "19"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    ido/* IDO_STAGE */.J_ === ido/* IDOStage.ROUND_2_END */.jA.ROUND_2_END && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-8 shadow-card1 bg-[#E0E1E1] p-6 rounded-lg",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "px-4 py-2 text-sm font-semibold text-center rounded-lg",
                                style: {
                                    background: "rgba(255, 255, 255, 0.50)"
                                },
                                children: "Round two complete"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center justify-center text-sm mt-7",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            i18n/* default.t */.Z.t("investment.target_goal", locale),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "font-semibold",
                                                children: i18n/* default.t */.Z.t("investment.3million", locale)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "h-6 w-[1px] bg-gray1 mx-4"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            i18n/* default.t */.Z.t("price", locale),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "font-semibold",
                                                children: "$0.035"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "h-6 w-[1px] bg-gray1 mx-4"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            "July ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "font-semibold",
                                                children: "22"
                                            }),
                                            " - August",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "font-semibold",
                                                children: "19"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    className: "w-[242px] bg-white h-[56px] text-sm",
                    radius: "xl",
                    variant: "outline",
                    onClick: function() {
                        if (!address) {
                            return login();
                        }
                        openInvestDialog();
                    },
                    children: "View my participation"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserInvestmentInfoDialog/* default */.Z, {
                opened: investDialogOpened,
                close: closeInvestDialog,
                campaignId: campaignId
            })
        ]
    });
};
/* harmony default export */ var ido_InvestmentIframe = (InvestmentIframe);


/***/ }),

/***/ 18084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94491);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67841);
/* harmony import */ var _hooks_useAccount__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98786);
/* harmony import */ var _components_common_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58163);
/* harmony import */ var _hooks_useRequest__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21706);






var UserInvestmentInfoDialog = function(param) {
    var opened = param.opened, close = param.close, campaignId = param.campaignId;
    var ref = (0,_hooks_useAccount__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(), address = ref.address, login = ref.login;
    var ref1 = (0,_hooks_useRequest__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(address && campaignId ? {
        function: "invest/getInvestmentInfo",
        data: {
            address: address,
            campaignId: 11
        },
        header: {
            endpoint: "network"
        }
    } : null), oldData = ref1.data;
    var ref2 = (0,_hooks_useRequest__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(address && campaignId ? {
        function: "invest/getInvestmentInfo",
        data: {
            address: address,
            campaignId: parseInt(campaignId)
        },
        header: {
            endpoint: "network"
        }
    } : null), data = ref2.data, mutate = ref2.mutate;
    var totalEarnedToken = ((data === null || data === void 0 ? void 0 : data.totalEarnedToken) || 0) + ((oldData === null || oldData === void 0 ? void 0 : oldData.totalEarnedToken) || 0);
    var totalInvestDollarAmount = ((data === null || data === void 0 ? void 0 : data.totalInvestDollarAmount) || 0) + ((oldData === null || oldData === void 0 ? void 0 : oldData.totalInvestDollarAmount) || 0);
    var totalBonusToken = ((data === null || data === void 0 ? void 0 : data.totalBonusToken) || 0) + ((oldData === null || oldData === void 0 ? void 0 : oldData.totalBonusToken) || 0);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (opened) {
            mutate();
        }
    }, [
        opened
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_5__/* .Modal */ .u, {
        opened: opened,
        onClose: close,
        centered: true,
        withCloseButton: false,
        classNames: {
            body: "py-10 px-8"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_icons__WEBPACK_IMPORTED_MODULE_3__/* .CloseIcon */ .Tw, {
                className: "absolute right-4 top-4 action",
                onClick: close
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col items-center font-exo",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-2xl font-extrabold text-dark1 text-center",
                        children: "Your IDO Investment"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mt-4 text-sm font-normal text-center",
                        children: "Once the IDO period end, you’ll have access to 10% of your invested amount."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "mt-4 w-full relative",
                        children: [
                            !address && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "absolute w-full h-full top-0 left-0 flex items-center justify-center z-10",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_6__/* .Button */ .z, {
                                    radius: "xl",
                                    size: "md",
                                    onClick: login,
                                    children: "Connect Wallet"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "px-6 py-8 bg-[#EBF3FF] rounded-lg text-center flex flex-col gap-8 w-full  ".concat(address ? "" : "blur-sm"),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "text-[#639EFC] font-extrabold text-4xl",
                                                children: totalEarnedToken || 0
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "text-xl font-semibold text-gray1 mt-2",
                                                children: "KAT token"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "text-[#639EFC] font-extrabold text-4xl",
                                                children: totalInvestDollarAmount || 0
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "text-xl font-semibold text-gray1 mt-2",
                                                children: "Participating Amount"
                                            })
                                        ]
                                    }),
                                    totalBonusToken ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex items-center justify-center font-bold",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "text-[#639EFC] ",
                                                children: [
                                                    "+",
                                                    totalBonusToken,
                                                    " KAT"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "ml-1",
                                                children: [
                                                    "($",
                                                    (totalBonusToken * 100 / totalEarnedToken).toFixed(0),
                                                    "% Bonus)"
                                                ]
                                            })
                                        ]
                                    }) : null
                                ]
                            })
                        ]
                    }),
                    address && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_6__/* .Button */ .z, {
                        className: "mt-6 w-[242px] !text-base h-[56px]",
                        radius: "xl",
                        onClick: close,
                        children: "Close"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (UserInvestmentInfoDialog);


/***/ }),

/***/ 81121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useInvestInfo; }
/* harmony export */ });
/* harmony import */ var _hooks_useAccount__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98786);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);



function useInvestInfo() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), totalInvest = ref[0], setTotalInvest = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("en"), locale = ref1[0], setLocale = ref1[1];
    var address = (0,_hooks_useAccount__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)().address;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    // const update = useCallback(() => {
    //   if (address) {
    //     fetch("https://api-dev.karatdao.com/test_backend/zado/action", {
    //       method: "POST",
    //       headers: {
    //         "content-type": "application/json",
    //       },
    //       body: JSON.stringify({
    //         method: "ido/status",
    //         params: {
    //           userAddress: address,
    //         },
    //       }),
    //     })
    //       .then((resp) => {
    //         return resp.json();
    //       })
    //       .then((result) => {
    //         if (result?.result?.totalAmount) {
    //           setTotalInvest(result.result.totalAmount);
    //         }
    //       });
    //   }
    // }, [address]);
    // useEffect(() => {
    //   update();
    // }, [address]);
    return {
        totalInvest: totalInvest,
        // update,
        locale: locale
    };
}


/***/ }),

/***/ 61839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ services_i18n; }
});

;// CONCATENATED MODULE: ./src/i18n/jp.json
var jp_namespaceObject = JSON.parse('{"price":"Price","dex":"DEX","first_round":"First Round","initial":"Initial","offering":"Offering","connect_wallet":"Connect wallet","sign_message":"Sign Message","target_goal":"Target goal","hero":{"round_1_target":"$0.5 Million","round_1_price":"$0.03","round_1_date":"July 19 - July 21"},"benefits":{"staking_benefits":"Token benefits","data_and_content_access":"Data and content access","data_and_content_access_description":"Utilize KAT tokens to gain access to data and exclusive content from other users on the Karat Network. This may include services like identity verification, data analysis tools, or exclusive content.","staking_and_rewards":"Staking and earning rewards","staking_and_rewards_description":"Token holders can stake their KAT tokens with various validators to secure the network and earn rewards as it grows.","governance":"Governance","governance_description":"Karat token holders can exercise their voting rights to actively engage in governance decisions concerning the network\'s development, future features, and rule changes."},"token_distribution":{"title":"Token distribution","desc1":"10% of the total token supply will be distributed at TGE","desc2":"Tokens released quarterly: 6% per release from total supply","desc3":"15 continuous quarters of scheduled releases"},"investment_limit":{"title":"Investment limits","desc1":"Minimum investment per address is $500 USDT*","desc2":"Referral link participants will be qualified for 3% extra allocation*","tip":"*Please note that rules may vary across different platforms and countries."},"investment":{"title":"Your IDO Investment","1million":"$0.5 million","target_goal_amount":"$0.5 million","investment_tip":"You can only invest once. Minimum investment limit is $500 USDT","investment_amount":"Investment amount","token":"token","invest":"Invest","invested_token":"Invested token","accessible_amount_august":"Accessible amount on August 19","second_round_coming_soon":"Second round coming soon","3million":"$3.5 million","round_1_date":"July 19 - July 21","round_2_date":"July 22 - August 19","success_tip":"Congratulations on your investment! Once the staking period end, you\'ll have access to 10% of your invested amount.","empty_amount_error":"Please enter an amount","max_amount_error":"You’ve exceeded the maximum amount of $500 USDT","enough_amount_error":"You don\'t have enough balance"}}');
;// CONCATENATED MODULE: ./src/i18n/en.json
var en_namespaceObject = JSON.parse('{"price":"Price","dex":"DEX","first_round":"First Round","initial":"Initial","offering":"Offering","connect_wallet":"Connect wallet","sign_message":"Sign Message","target_goal":"Target goal","hero":{"round_1_target":"$0.5 Million","round_1_price":"$0.03","round_1_date":"July 19 - July 21"},"benefits":{"staking_benefits":"Token benefits","data_and_content_access":"Data and content access","data_and_content_access_description":"Utilize KAT tokens to gain access to data and exclusive content from other users on the Karat Network. This may include services like identity verification, data analysis tools, or exclusive content.","staking_and_rewards":"Staking and earning rewards","staking_and_rewards_description":"Token holders can stake their KAT tokens with various validators to secure the network and earn rewards as it grows.","governance":"Governance","governance_description":"Karat token holders can exercise their voting rights to actively engage in governance decisions concerning the network\'s development, future features, and rule changes."},"token_distribution":{"title":"Token distribution","desc1":"10% of the total token supply will be distributed at TGE","desc2":"Tokens released quarterly: 6% per release from total supply","desc3":"15 continuous quarters of scheduled releases"},"investment_limit":{"title":"Investment limits","desc1":"Minimum investment per address is $500 USDT*","desc2":"Referral link participants will be qualified for 3% extra allocation*","tip":"*Please note that rules may vary across different platforms and countries."},"investment":{"title":"Your IDO Investment","1million":"$0.5 million","target_goal_amount":"$0.5 million","investment_tip":"You can only invest once. Minimum investment limit is $500 USDT","investment_amount":"Investment amount","token":"token","invest":"Invest","invested_token":"Invested token","accessible_amount_august":"Accessible amount on August 19","second_round_coming_soon":"Second round coming soon","3million":"$3.5 million","round_1_date":"July 19 - July 21","round_2_date":"July 22 - August 19","success_tip":"Congratulations on your investment! Once the staking period end, you\'ll have access to 10% of your invested amount.","empty_amount_error":"Please enter an amount","max_amount_error":"You’ve exceeded the maximum amount of $500 USDT","enough_amount_error":"You don\'t have enough balance"}}');
;// CONCATENATED MODULE: ./src/i18n/index.ts


var trans = {
    en: en_namespaceObject,
    jp: jp_namespaceObject
};
/* harmony default export */ var i18n = (trans);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
;// CONCATENATED MODULE: ./src/services/i18n.ts


(lodash_default()).templateSettings.interpolate = /{{([\s\S]+?)}}/g;
/* harmony default export */ var services_i18n = ({
    t: function t(key) {
        var locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "en", context = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        // @ts-ignore
        return lodash_default().template(lodash_default().get(i18n[locale], key), {
            interpolate: /{{([\s\S]+?)}}/g
        })(context);
    },
    locale: "en"
});


/***/ }),

/***/ 59498:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H4": function() { return /* binding */ currentRound; },
/* harmony export */   "J_": function() { return /* binding */ IDO_STAGE; },
/* harmony export */   "jA": function() { return /* binding */ IDOStage; }
/* harmony export */ });
/* unused harmony exports USDT_ADDRESS, CHAIN_ID, CAMPAIGN_ADDRESS, getCurrentRound */
var USDT_ADDRESS = "0x983E478F15bd1848B5B9014771DEdd049bBa5Df4";
var CHAIN_ID = 5;
var CAMPAIGN_ADDRESS = "0xDa3ea2222f2cF23BA3bb2063F8E7a5Edb1762694";
var IDOStage;
(function(IDOStage) {
    IDOStage[IDOStage["ROUND_1"] = 1] = "ROUND_1";
    IDOStage[IDOStage["ROUND_1_END"] = 2] = "ROUND_1_END";
    IDOStage[IDOStage["ROUND_2"] = 3] = "ROUND_2";
    IDOStage[IDOStage["ROUND_2_END"] = 4] = "ROUND_2_END";
})(IDOStage || (IDOStage = {}));
var IDO_STAGE = parseInt("3");
function getCurrentRound(stage) {
    switch(stage){
        case IDOStage.ROUND_1:
            return 1;
        case IDOStage.ROUND_1_END:
            return 1;
        case IDOStage.ROUND_2:
            return 2;
        case IDOStage.ROUND_2_END:
            return 2;
        default:
            return 1;
    }
}
var currentRound = getCurrentRound(IDO_STAGE);


/***/ }),

/***/ 3558:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "r": function() { return /* binding */ n; }
});

// UNUSED EXPORTS: createStore

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-hooks-global-state/node_modules/zustand/esm/vanilla.js
const createStoreImpl = (createState) => {
  let state;
  const listeners = /* @__PURE__ */ new Set();
  const setState = (partial, replace) => {
    const nextState = typeof partial === "function" ? partial(state) : partial;
    if (nextState !== state) {
      const previousState = state;
      state = replace ? nextState : Object.assign({}, state, nextState);
      listeners.forEach((listener) => listener(state, previousState));
    }
  };
  const getState = () => state;
  const subscribe = (listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  };
  const destroy = () => listeners.clear();
  const api = { setState, getState, subscribe, destroy };
  state = createState(
    setState,
    getState,
    api
  );
  return api;
};
const createStore = (createState) => createState ? createStoreImpl(createState) : createStoreImpl;



// EXTERNAL MODULE: ./node_modules/use-sync-external-store/shim/with-selector.js
var with_selector = __webpack_require__(52798);
;// CONCATENATED MODULE: ./node_modules/react-hooks-global-state/node_modules/zustand/esm/index.js






const { useSyncExternalStoreWithSelector } = with_selector;
function useStore(api, selector = api.getState, equalityFn) {
  const slice = useSyncExternalStoreWithSelector(
    api.subscribe,
    api.getState,
    api.getServerState || api.getState,
    selector,
    equalityFn
  );
  (0,react.useDebugValue)(slice);
  return slice;
}
const createImpl = (createState) => {
  const api = typeof createState === "function" ? createStore(createState) : createState;
  const useBoundStore = (selector, equalityFn) => useStore(api, selector, equalityFn);
  Object.assign(useBoundStore, api);
  return useBoundStore;
};
const create = (createState) => createState ? createImpl(createState) : createImpl;
var create$1 = create;



;// CONCATENATED MODULE: ./node_modules/react-hooks-global-state/dist/index.modern.js
const o=(t,e)=>{if(!t.includes(e))throw new Error(`'${e}' not found. It must be provided in initialState as a property key.`)},n=r=>{const n=create$1(()=>r),s=Object.keys(r),a=(t,e)=>{ false&&0,n.setState(r=>{return{[t]:(o=r[t],n=e,"function"==typeof n?n(o):n)};var o,n})};return{useGlobalState:e=>{ false&&0;const r=(0,react.useCallback)(t=>t[e],[e]);return[n(r),(0,react.useCallback)(t=>a(e,t),[e])]},getGlobalState:t=>( false&&0,n.getState()[t]),setGlobalState:a,subscribe:(t,e)=>{n.subscribe((r,o)=>{r[t]!==o[t]&&e(r[t])})}}},s=(o,n=o(void 0,{type:void 0}),a)=>{if(a)return a(s)(o,n);const i=e(r(o,n)),u=Object.keys(n),c=e=>{ false&&0;const r=t(t=>t[e],[e]);return i(r)};return{useStoreState:c,useGlobalState:e=>( false&&0,[c(e),t(t=>{i.setState(r=>{return{[e]:(o=r[e],n=t,"function"==typeof n?n(o):n)};var o,n})},[e])]),getState:i.getState,dispatch:i.dispatch}};
//# sourceMappingURL=index.modern.js.map


/***/ })

}]);